import Swiper from 'swiper';
import SwiperCore, { Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Navigation, Scrollbar]);

export class BeforeAndAfterCarousel {
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.init();
    }

    init () {
        new Swiper(this.sliderElement, {
            slidesPerView: 'auto',
            spaceBetween: 14,
            threshold: 10,
            centerInsufficientSlides: true,
            navigation: {
                nextEl: this.sliderElement.querySelector('.swiper-button-next'),
                prevEl: this.sliderElement.querySelector('.swiper-button-prev')
            },
            scrollbar: {
                el: this.sliderElement.querySelector('.swiper-scrollbar'),
                draggable: true
            }
        });
    }
}

export class BeforeAndAfterToggle {
    constructor (element) {
        if (!element) return;

        this.toggleElementsContainer = element;
        this.afterContent = this.toggleElementsContainer.querySelector('.js-before-and-after-content-after');
        this.beforeControl = this.toggleElementsContainer.querySelector('.js-before-and-after-toggle-before');
        this.afterControl = this.toggleElementsContainer.querySelector('.js-before-and-after-toggle-after');
        this.toggleCurrent = this.toggleElementsContainer.querySelector('.js-before-and-after-toggle-current');

        this.init();
    }

    init () {
        this.beforeControl.addEventListener('click', () => {
            if (this.afterControl.classList.contains('active')) {
                this.beforeControl.classList.add('active');
                this.afterControl.classList.remove('active');
                this.afterContent.classList.remove('active');

                this.toggleCurrent.style.transform = null;
                this.toggleCurrent.style.width = null;
            }
        });

        this.afterControl.addEventListener('click', () => {
            if (this.beforeControl.classList.contains('active')) {
                this.afterControl.classList.add('active');
                this.beforeControl.classList.remove('active');
                this.afterContent.classList.add('active');

                this.toggleCurrent.style.transform = `translateX(${(this.afterControl.getBoundingClientRect().x - this.beforeControl.getBoundingClientRect().x) / 16}rem)`;
                this.toggleCurrent.style.width = `${this.afterControl.getBoundingClientRect().width / 16}rem`;
            }
        });
    }
}
